<template>
  <div
    v-member-hover-preview:[{disabled:memberHoverDisabled}]="firstMember"
    class="filter-pill-avatar-count"
    :class="{ 'ml-0': !displayMultipleFilterIcons && !showUserAvatars }"
  >
    {{ countLabel }}
  </div>
</template>

<script>
export default {
  props: {
    countLabel: {
      type: String,
      required: true,
    },
    displayMultipleFilterIcons: {
      type: Boolean,
      default: false,
    },
    hasNoAssignees: {
      type: Boolean,
      default: false,
    },
    showUserAvatars: {
      type: Boolean,
      default: false,
    },
    valuesCount: {
      type: Number,
      default: 0,
    },
    firstMember: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    memberHoverDisabled() {
      return !this.showUserAvatars || this.hasNoAssignees || this.valuesCount !== 1;
    },
  },
};
</script>

<style lang="scss">
.filter-pill-avatar-count {
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: $stPrimaryColor;
  @apply max-w-[150px]
    whitespace-nowrap
    text-ellipsis
    overflow-hidden
    text-text-default;
  margin-left: 5px;
}
</style>
